<template>
  <div>
    <v-file-input
      v-model="uploadfile.file"
      accept="image/*"
      :label="label"
      prepend-icon="mdi-image"
      ref="rfafile"
      @change="changeFile"
      outlined
      background-color="white"
    ></v-file-input>
  </div>
</template>

<script>
export default {
  props: {
    record: Object,
    label: String,
    init: String,
  },
  data() {
    return {
      data: {
        Page_id: 0,
        Report_id: null,
        Records: [{ value: "", form_id: 0, form_type: 9 }],
      },
      uploadfile: {
        file: {},
        url: "",
        data: { name: "", size: 0, type: "" },
      },
      rules: { required: (value) => !!value || "必須項目です" },
    };
  },
  async mounted() {
    //初期処理
    this.data.Records[0] = this.record;
    this.size = 2;
  },
  methods: {
    changeFile() {},
  },
};
</script>

<style></style>
